import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      const main = document.querySelector('main');
      if (main && (main as HTMLElement).scrollTo) {
        (main as HTMLElement).scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }
    } catch (e) {
      // ignore
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
